import React, {useState, useEffect, memo} from "react";
import { useSelector } from "react-redux";
import Header from "./Includes/Header"
import DashboardHeader from "./Includes/DashboardHeader";
import AdminHeader from "./Includes/AdminHeader";
import Footer from "./Includes/Footer"

const TermsOfUse = () => {
    const [header, setHeader] = useState("guest");
    const { auth } = useSelector((state) => state);
	useEffect(() => {
		if(auth.data){
			let response=auth.data;
			if(response.status==1){
				if(response.user.role!=1){
					setHeader("dashboard");
				}
				else{
					setHeader("admin");
				}
			}
			else{
				setHeader("guest");
			}
		}
	}, [auth]);
    return (
        <div>
            {
				(header==="guest")?<Header/>:(header==="dashboard")?<DashboardHeader/>:<AdminHeader/>
			}
            <div className="main_content">
                <div className="container_cust legal-page">
                    <div className="legal-header">
                        <h1 className="title-main">Terms of Use</h1>
                        <p className="legal-meta">Effective Date: 24 Mar 2026 &nbsp;|&nbsp; Last Updated: 24 Mar 2026</p>
                    </div>

                    <section className="legal-section">
                        <h2>1. Introduction</h2>
                        <p>Welcome to Treasury ("Platform"), a real estate tokenization platform operated by Treasury Technology Company ("Treasury", "we", "us", or "our"), registered in the Kingdom of Saudi Arabia. By accessing or using the Platform at platform.treasury.sa, you ("User", "you") agree to be bound by these Terms of Use ("Terms"). If you do not agree to these Terms, you must not access or use the Platform.</p>
                        <p>These Terms constitute a legally binding agreement between you and Treasury. We reserve the right to update these Terms at any time. Continued use of the Platform following any update constitutes acceptance of the revised Terms.</p>
                    </section>

                    <section className="legal-section">
                        <h2>2. Eligibility</h2>
                        <p>To access and use the Platform, you must:</p>
                        <ul>
                            <li>Be a resident of the Kingdom of Saudi Arabia or otherwise permitted by applicable law to use the Platform;</li>
                            <li>Be at least 18 years of age;</li>
                            <li>Have completed identity verification through Nafath (the national digital identity platform);</li>
                            <li>Not be subject to any sanctions, restrictions, or prohibitions under Saudi law or applicable international regulations.</li>
                        </ul>
                        <p>Treasury reserves the right to refuse access or terminate accounts at its sole discretion if eligibility requirements are not met.</p>
                    </section>

                    <section className="legal-section">
                        <h2>3. Account Registration and Security</h2>
                        <p>You are required to register an account to access the Platform's investment features. You agree to:</p>
                        <ul>
                            <li>Provide accurate, current, and complete information during registration;</li>
                            <li>Maintain the security and confidentiality of your login credentials;</li>
                            <li>Notify Treasury immediately at partnerships@treasury.sa of any unauthorised access or suspected breach of your account;</li>
                            <li>Accept full responsibility for all activities conducted under your account.</li>
                        </ul>
                        <p>Treasury will not be liable for any loss or damage arising from your failure to maintain the security of your account credentials.</p>
                    </section>

                    <section className="legal-section">
                        <h2>4. Know Your Customer (KYC) and Identity Verification</h2>
                        <p>The Platform requires identity verification through Nafath prior to any investment activity. By completing KYC, you consent to Treasury processing your personal data in accordance with our Privacy Policy and applicable Saudi regulations, including the Personal Data Protection Law (PDPL).</p>
                    </section>

                    <section className="legal-section">
                        <h2>5. Investment Services and Tokenized Real Estate</h2>
                        <p>Treasury provides a platform for the subscription and secondary trading of tokenized real estate assets registered with the Real Estate Registry (RER). By using the investment features of the Platform, you acknowledge and agree that:</p>
                        <ul>
                            <li><strong>Investments carry risk.</strong> The value of tokenized real estate assets may fluctuate, and past performance is not indicative of future results.</li>
                            <li><strong>No guaranteed returns.</strong> Treasury does not guarantee any specific return on investment.</li>
                            <li><strong>Regulatory compliance.</strong> The Platform operates under the REGA Regulatory Sandbox framework. Certain features may be subject to regulatory approval and may change.</li>
                            <li><strong>Minimum investment.</strong> Minimum subscription amounts apply per property listing as displayed on the Platform.</li>
                            <li><strong>Sell orders.</strong> You may only place sell orders for assets you currently hold. Short selling is not permitted.</li>
                        </ul>
                    </section>

                    <section className="legal-section">
                        <h2>6. Fees and Charges</h2>
                        <p>Treasury charges platform fees on transactions as disclosed on the relevant property listing page. Fees are subject to change with prior notice. All fees are inclusive of applicable VAT where required by Saudi law.</p>
                    </section>

                    <section className="legal-section">
                        <h2>7. Wallet and Funds</h2>
                        <p>The Platform provides a built-in digital wallet for managing your funds. You agree that:</p>
                        <ul>
                            <li>Funds deposited into your wallet are held for investment purposes on the Platform only;</li>
                            <li>Withdrawal requests are subject to verification and processing times as stated on the Platform;</li>
                            <li>Treasury is not a bank and does not provide banking services; wallet balances do not accrue interest.</li>
                        </ul>
                    </section>

                    <section className="legal-section">
                        <h2>8. Prohibited Activities</h2>
                        <p>You agree not to:</p>
                        <ul>
                            <li>Use the Platform for any unlawful purpose or in violation of any applicable law or regulation;</li>
                            <li>Engage in market manipulation, fraudulent activity, or misrepresentation;</li>
                            <li>Attempt to gain unauthorised access to any part of the Platform or its systems;</li>
                            <li>Upload or transmit malicious code, viruses, or harmful content;</li>
                            <li>Use automated tools, bots, or scrapers to access the Platform without prior written consent;</li>
                            <li>Impersonate any person or entity or misrepresent your affiliation with any person or entity.</li>
                        </ul>
                    </section>

                    <section className="legal-section">
                        <h2>9. Intellectual Property</h2>
                        <p>All content on the Platform, including but not limited to text, graphics, logos, icons, images, and software, is the property of Treasury or its licensors and is protected by applicable intellectual property laws. You may not reproduce, distribute, or create derivative works without Treasury's prior written consent.</p>
                    </section>

                    <section className="legal-section">
                        <h2>10. Limitation of Liability</h2>
                        <p>To the fullest extent permitted by applicable law, Treasury shall not be liable for:</p>
                        <ul>
                            <li>Any indirect, incidental, special, consequential, or punitive damages;</li>
                            <li>Loss of profits, revenue, data, or investment value;</li>
                            <li>Any interruption or unavailability of the Platform;</li>
                            <li>Actions or omissions of third parties, including the Real Estate Registry (RER) or Nafath.</li>
                        </ul>
                        <p>Treasury's total aggregate liability to you shall not exceed the total fees paid by you to Treasury in the twelve (12) months preceding the event giving rise to the claim.</p>
                    </section>

                    <section className="legal-section">
                        <h2>11. Indemnification</h2>
                        <p>You agree to indemnify, defend, and hold harmless Treasury, its officers, directors, employees, and agents from and against any claims, liabilities, damages, losses, and expenses arising out of or in connection with your use of the Platform, your violation of these Terms, or your violation of any applicable law.</p>
                    </section>

                    <section className="legal-section">
                        <h2>12. Third-Party Services</h2>
                        <p>The Platform integrates with third-party services including Nafath (KYC), the Real Estate Registry (RER), and payment processors. Treasury is not responsible for the availability, accuracy, or content of such third-party services. Your use of third-party services is subject to their respective terms and policies.</p>
                    </section>

                    <section className="legal-section">
                        <h2>13. Suspension and Termination</h2>
                        <p>Treasury reserves the right to suspend or terminate your account and access to the Platform at any time, with or without notice, for any reason including but not limited to violation of these Terms, suspected fraudulent activity, or regulatory requirements. Upon termination, your right to use the Platform ceases immediately. Any outstanding obligations, including pending transactions, will be handled in accordance with applicable regulations.</p>
                    </section>

                    <section className="legal-section">
                        <h2>14. Governing Law and Dispute Resolution</h2>
                        <p>These Terms are governed by and construed in accordance with the laws of the Kingdom of Saudi Arabia. Any dispute arising out of or in connection with these Terms shall be subject to the exclusive jurisdiction of the competent courts of the Kingdom of Saudi Arabia.</p>
                    </section>

                    <section className="legal-section legal-contact">
                        <h2>15. Contact</h2>
                        <p>For any questions regarding these Terms, please contact us at:</p>
                        <p>
                            <strong>Treasury Technology Company</strong><br/>
                            7076 Al Sahaba Rd., Ishbiliyah 13225, Riyadh, Saudi Arabia<br/>
                            Email: <a href="mailto:partnerships@treasury.sa">partnerships@treasury.sa</a><br/>
                            Platform: <a href="https://platform.treasury.sa">platform.treasury.sa</a>
                        </p>
                    </section>
                </div>
            </div>    
            <Footer />
        </div>
    );
};

export default memo(TermsOfUse);
